import React from 'react';
import { ConfirmShipmentErrorModalTemplate } from 'themes/modules/order/pages';

function ConfirmShipmentErrorModal(props) {
    return <ConfirmShipmentErrorModalTemplate {...props} />;
}

export default ConfirmShipmentErrorModal;
